import SeguimientoIcon, {} from "../../../../icons/SeguimientoYMonitoreo/SeguimientoIcons";
import {tipoIndicador} from "../SeguimentoConstantes";
import {getColorIndicadores, getContrast} from "../SeguimientoMonitoreutility";
const Indicadores = ({viajeId, indicadores, onMouseEnter, onMouseLeave, esSeguimientoMonitoreo}) => {

    const handleMouseEnter = (e, tipo) => {
        onMouseEnter(e, tipo, viajeId)
    }

    indicadores = indicadores || [];

    // const indicadores = viaje?.indicadores ?? {};

    const velocidad = indicadores[tipoIndicador.velocidad];
    const motor = indicadores[tipoIndicador.motor];
    const geocercaProhibida = indicadores[tipoIndicador.geocercaProhibida];
    const gps = indicadores[tipoIndicador.gps];
    const lastPosition = indicadores[tipoIndicador.lastPosition];
    const diesel = indicadores[tipoIndicador.diesel];
    const sinViaje = indicadores[tipoIndicador.unidadSinViaje];
    const horasManejo = indicadores[tipoIndicador.horasManejo];
    const botonPanico = indicadores[tipoIndicador.botonPanico];
    const seguimiento = indicadores[tipoIndicador.seguimiento];
    const detenidoZonaNoSegura = indicadores[tipoIndicador.detenidoZonaNoSegura];
    const despacho = indicadores[tipoIndicador.despacho];

    return (
        <>
            <span className={getColorIndicadores(velocidad)}>
                <SeguimientoIcon iconName={`Velocidad${getContrast(velocidad)}`}
                                 onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.velocidad)}
                                 onMouseLeave={onMouseLeave}
                />
            </span>
            <span className={getColorIndicadores(gps)}>
                        <SeguimientoIcon iconName={`Gps${getContrast(gps)}`}
                                         onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.gps)}
                                         onMouseLeave={onMouseLeave}
                        />
                    </span>
            {!esSeguimientoMonitoreo &&
                <span className={getColorIndicadores(motor)}>
                    <SeguimientoIcon iconName={`Motor${getContrast(motor)}`}
                                     onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.motor)}
                    />
                </span>
            }
            {esSeguimientoMonitoreo &&
                <>
                    <span className={getColorIndicadores(lastPosition)}>
                        <SeguimientoIcon iconName={`LastPosition${getContrast(lastPosition)}`}
                                         onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.lastPosition)}
                                         onMouseLeave={onMouseLeave}
                        />
                    </span>

                    <span className={getColorIndicadores(seguimiento)}>
                        <SeguimientoIcon iconName={`Seguimiento${getContrast(seguimiento)}`}
                                         onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.seguimiento)}
                                         onMouseLeave={onMouseLeave}
                        />
                    </span>

                    <span className={getColorIndicadores(despacho)}>
                        <SeguimientoIcon iconName={`Despacho${getContrast(despacho)}`}
                                         onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.despacho)}
                                         onMouseLeave={onMouseLeave}
                        />
                    </span>

                </>
            }
            {!esSeguimientoMonitoreo &&
                <>
                    <span className={getColorIndicadores(horasManejo)}>
                        <SeguimientoIcon
                            onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.horasManejo)}
                            onMouseLeave={onMouseLeave}
                            iconName={`HorasManejo${getContrast(horasManejo)}`}/>
                    </span>

                    <span className={getColorIndicadores(geocercaProhibida)}>
                        <SeguimientoIcon iconName={`GeocercaProhibida${getContrast(geocercaProhibida)}`}/>
                    </span>
                    <span className={getColorIndicadores(sinViaje)}>
                        <SeguimientoIcon iconName={`SinViaje${getContrast(sinViaje)}`}/>
                    </span>
                    <span className={getColorIndicadores(botonPanico)}>
                        <SeguimientoIcon
                            onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.botonPanico)}
                            onMouseLeave={onMouseLeave}
                            iconName={`BotonPanico${getContrast(botonPanico)}`}/>
                    </span>
                    <span className={getColorIndicadores(detenidoZonaNoSegura)}>
                        <SeguimientoIcon
                            onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.detenidoZonaNoSegura)}
                            onMouseLeave={onMouseLeave}
                            iconName={`DetenidoZonaNoSegura${getContrast(detenidoZonaNoSegura)}`}/>
                    </span>
                     <span className={getColorIndicadores(diesel)}>
                        <SeguimientoIcon
                            onMouseEnter={(e) => handleMouseEnter(e, tipoIndicador.diesel)}
                            onMouseLeave={onMouseLeave}
                            iconName={`Diesel${getContrast(diesel)}`}/>
                    </span>
                </>
            }
        </>
    )
}
export default Indicadores;